<h3 class="schema__advantage-item-title schema__advantage-item-title-dark">
  {{ 'main.schemas.statisticsDetailing' | translate }}
</h3>

<div class="schema__card schema__paragraph-regular schema__paragraph-dark">
  {{ 'main.schemas.detailedAnalytics' | translate }}
</div>

<img
  width="156.5"
  loading="lazy"
  alt="Three AstralFund credit cards"
  src="/assets/schemas/card-2-bg.png"
  class="schema__image schema__image_2"
/>
